module.exports = __webpack_public_path__ + "static/media/cbc-news.a0c5b180.jpg";